import React from 'react';
import styled, {keyframes} from 'styled-components';

const TRIVIA_CARDS = ['❓', '💡', '🧠', '🎯', '⭐'];

export const CardFan = ({size = 'large'}) => {
    const isSmall = size === 'small';
    return (
        <FanWrap $small={isSmall}>
            {TRIVIA_CARDS.map((icon, i) => (
                <FanCard key={i} $i={i} $total={TRIVIA_CARDS.length} $small={isSmall}>
                    <FanCardInner $small={isSmall}>{icon}</FanCardInner>
                </FanCard>
            ))}
        </FanWrap>
    );
};

const fanOpen = keyframes`
    0% { transform: rotate(0deg); opacity: 0; }
    40% { opacity: 1; }
    100% { transform: rotate(var(--fan-angle)); opacity: 1; }
`;

const FanWrap = styled.div`
    position: relative;
    width: ${p => p.$small ? '140px' : '270px'};
    height: ${p => p.$small ? '70px' : '135px'};
    margin: ${p => p.$small ? '0 auto' : '0 auto'};
`;

const FanCard = styled.div`
    position: absolute;
    left: 50%;
    bottom: 0;
    width: ${p => p.$small ? '42px' : '78px'};
    height: ${p => p.$small ? '58px' : '108px'};
    margin-left: ${p => p.$small ? '-21px' : '-39px'};
    transform-origin: 50% 100%;
    --fan-angle: ${p => (p.$i - (p.$total - 1) / 2) * 18}deg;
    animation: ${fanOpen} 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) ${p => 0.3 + p.$i * 0.1}s both;
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.4));
`;

const FanCardInner = styled.div`
    width: 100%;
    height: 100%;
    background: linear-gradient(145deg, #2d1b69, #1a1145);
    border-radius: ${p => p.$small ? '5px' : '9px'};
    border: ${p => p.$small ? '1.5px' : '3px'} solid rgba(139, 92, 246, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${p => p.$small ? '20px' : '36px'};
`;
